import { NetworkStatus } from '@cbridge-utils/network';
import { IPricingRuleStore } from './pricingRule.interface';

export const pricingRuleInitialState: IPricingRuleStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
